export const ACCOUNT_MANAGER_REPORT_ID = 'account-manager';
